<div class="nav-list-content" [ngClass]="{ inactive: isDisabled, selected: isActive && !isDisabled }">
	<div class="printable_button" *ngIf="isActive && !isDisabled">
		<app-printable-report-item-r1></app-printable-report-item-r1>
	</div>

	<li
		(click)="allow ? navigate() : (allow = false)"
		[ngClass]="{ inactive: isDisabled, selected: isActive && !isDisabled }"
	>
		<div>
			<span class="sectiontitle" [ngClass]="sectiontitle + '_nav_link'">{{ sectiontitle }}</span>
			<div class="download_report" *ngIf="isR6">
				<div class="child" *ngIf="loadR6Printable">
					<app-printable-report-component-r6 class="download_report_pdf"></app-printable-report-component-r6>
					<app-product-csv-downnload-r6 [key]="sectiontitle" class="download_report_csv"></app-product-csv-downnload-r6>
				</div>
			</div>
			<span *ngIf="downloadConfiguration.enableDownload && !isDisabled">
				<a href="javascript:void(0)" target="_blank" (click)="downloadCSV($event)">
					<i
						class="fa fa-download downloadIcon"
						aria-hidden="true"
						style="font-size: 0.8em; color: #000; top: 2px; position: relative"
					></i>
				</a>
			</span>
			<span class="underline"> </span>
		</div>
	</li>
</div>
